/**
 * Electron detection and utilities
 */

/**
 * Check if the app is running in Electron
 */
export function isElectron(): boolean {
  return typeof window !== 'undefined' && 
         typeof window.electronAPI !== 'undefined';
}

/**
 * Get Electron API if available
 */
export function getElectronAPI(): typeof window.electronAPI | null {
  if (isElectron()) {
    return window.electronAPI;
  }
  return null;
}

